import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { PageHeader } from '@dashboard/components/PageHeader';
import { Skeleton } from '@dashboard/components/ui/skeleton';
import { useLinkInBio } from '@dashboard/hooks/useLinkInBio';
import hasLinkInBioLab from '@dashboard/lib/linkInBioLab';
import LinkSettings from './components/LinkSettings';

export default function LinkInBioSettings() {
  const { seller, isAuthenticating } = useAuth();
  const hasLab = hasLinkInBioLab(seller);
  const { data, isError } = useLinkInBio({ enabled: hasLab });

  if (!isAuthenticating && seller?._id && !hasLab) {
    return <Redirect to="/" />;
  }

  return (
    <div className="space-y-4 p-4">
      <PageHeader title="Link in bio settings" />
      {isError ? (
        <p className="p-16 text-center text-sm text-muted-foreground">
          We could not load your link in bio. Refresh the page to try again.
        </p>
      ) : !data ? (
        <div className="max-w-2xl space-y-3" role="status" aria-label="Loading settings">
          <Skeleton className="h-5 w-32" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
        </div>
      ) : (
        <div className="max-w-2xl space-y-6">
          <LinkSettings savedPublished={data.linkInBio.published} />
        </div>
      )}
    </div>
  );
}
